import React, {useMemo} from 'react';

import {ValidationContextProvider} from 'src/contexts/validation-context';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import FormSection from '@pb/kit-component-form-section';
import Icon, {Icons} from '@pb/kit-component-icon';
import {useShown} from '@pb/kit-hooks-use-shown';


import {CreateConferenceModal} from './create-conference-modal';

import {
    noConferencePage,
    noConferencePageLabel,
    noConferencePageWarningIcon,
} from './no-conference-page.module.styl';

export const NoConferencePageComponent = ({accountId, onAssign}: Props) => {
    const {onClick, shown, onClose} = useShown();
    const {hasAccess} = useAdminAccessRight();

    const showCreateConferenceButton = useMemo(
        () => hasAccess(ACCESS_RIGHTS.CONFERENCE_SETUP),
        [hasAccess],
    );

    return (
        <div className={noConferencePage}>
            <FormSection headline="No Conference" className={noConferencePageLabel}>
                <Icon className={noConferencePageWarningIcon} type={Icons.ERROR}/> This account has no conference
            </FormSection>
            {showCreateConferenceButton ? (
                <Button
                    variant="Type.PRIMARY"
                    onClick={onClick}>
                    New Conference
                </Button>
            ) : null}
            <Dialog shown={shown} setShown={onClose} wrapperProps={{style: {width: 700}}}>
                <CreateConferenceModal
                    onClose={onClose}
                    accountId={accountId}
                    onAssign={onAssign}
                />
            </Dialog>
        </div>
    );
};

type Props = {
    accountId: number,
    onAssign: () => void,
};

export const NoConferencePage = ({accountId, onAssign}: Props) => (
    <ValidationContextProvider>
        <NoConferencePageComponent accountId={accountId} onAssign={onAssign}/>
    </ValidationContextProvider>
);
